import { decodeJwt } from "jose";

// Session token helpers.
//
// Tokens are issued and verified by the API (POST /auth/microsoft); the
// browser holds no signing secret. Here we only read the token to show who is
// signed in and to spot an expired or legacy (browser-signed) token early —
// the server still checks every request.

const TOKEN_KEY = "token";
const ISSUER = "attendance-api";

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (e) {
    return null;
  }
};

export const setToken = (token) => {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch (e) {
    // Storage unavailable — the user will need to sign in again
  }
};

export const clearSession = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch (e) {
    // ignore
  }
};

// Returns { payload: { sub: user } } (the shape callers already use), or
// rejects when the token is missing, expired, or not issued by the API.
export const verifyToken = async (jwtToken) => {
  if (!jwtToken) throw new Error("No session");
  let claims;
  try {
    claims = decodeJwt(jwtToken);
  } catch (e) {
    throw new Error("Malformed session token");
  }
  if (claims.iss !== ISSUER || !claims.user) throw new Error("Session token is not from the API");
  if (typeof claims.exp === "number" && claims.exp * 1000 <= Date.now()) {
    throw new Error("Session expired");
  }
  return { payload: { ...claims, sub: claims.user } };
};
